{
  "ResultFields": {
    "role": "角色",
    "button": "结果字段",
    "title": "结果字段",
    "onlyMe": "仅自己可见",
    "line": "第二行",
    "lineLimit": "最多 {{max}} 个",
    "lineEmpty": "名称下方不显示内容。",
    "order": "第二行字段顺序",
    "noCatalog": "没有可显示的字段。",
    "right": "右侧",
    "rightHint": "图片始终排在最后。",
    "pictures": "图片",
    "reset": "恢复默认"
  },
  "ResourceFieldSections": {
    "label": "资源字段",
    "groups": {
      "profile": "资料",
      "contact": "联系方式",
      "social": "社交媒体",
      "custom": "自定义字段"
    }
  }
}
